const isDashboard = (url) => /:\/\/[^./]*dashboard\./
  .test(url);

// eslint-disable-next-line unicorn/prefer-module
module.exports = isDashboard;
